/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OfferAnswerRatings = 'Zero' | 'One' | 'Two' | 'Three' | 'Four' | 'Max';

export const OfferAnswerRatings = {
    Zero: 'Zero' as OfferAnswerRatings,
    One: 'One' as OfferAnswerRatings,
    Two: 'Two' as OfferAnswerRatings,
    Three: 'Three' as OfferAnswerRatings,
    Four: 'Four' as OfferAnswerRatings,
    Max: 'Max' as OfferAnswerRatings
};

